class GravityForms {
	init() {
		jQuery(document).on('gform_post_render', this.setupListeners.bind(this));
		jQuery(document).on('gform_post_render', this.setWexCodes.bind(this));
	}

	setWexCodes() {
		this.setCouponCode();
		this.setLocationCode();
	}

	setupListeners() {
		const inputs = document.querySelectorAll('.gfield input, .gfield select, .gfield textarea');

		inputs.forEach((input) => {
			this.setNotEmpty(input);
			input.addEventListener('keyup', this.handleInputChange.bind(this));
			input.addEventListener('change', this.handleInputChange.bind(this));
		});
	}

	handleInputChange(event) {
		const { currentTarget } = event;
		this.setNotEmpty(currentTarget);
	}

	setNotEmpty(element) {
		const field = element.closest('.gfield, .gform-grid-col');
		if (null === field) {
			return;
		}

		if (element.value.length) {
			field.classList.add('not-empty');
		} else {
			field.classList.remove('not-empty');
		}
	}

	setCouponCode() {
		const couponCode = WexCouponCode.getValue(); // eslint-disable-line
		if (!couponCode) return;

		// find the coupon code fields
		const couponFields = document.querySelectorAll('.wex_coupon_code');
		if (!couponFields.length) return;

		// set the coupon code value
		couponFields.forEach((field) => {
			field.querySelector('input').value = couponCode;
		});
	}

	setLocationCode() {
		const locationCode = WexLocationCode.getValue(); // eslint-disable-line
		if (!locationCode) return;

		// find the location code fields
		const locationFields = document.querySelectorAll('.wex_location_code');
		if (!locationFields.length) return;

		// set the location code value
		locationFields.forEach((field) => {
			field.querySelector('input').value = locationCode;
		});
	}
}

export default new GravityForms();
